import type { Environment } from '@livecontrol/command-center/frontend';
import qs from 'qs';
import { environment as pro } from './environment.pro';

export const environment: Readonly<Environment> =
  qs.parse(window.location.search, { ignoreQueryPrefix: true }).env === 'pro'
    ? pro
    : Object.freeze({
       production: false,
        COGNITO_POOL_ID: 'us-west-1_XLqeANhKz',
        COGNITO_APP_CLIENT_ID: '15bq1oi87rarmn711bot780vj4',
        // GRAPHQL_URI: 'https://scheduler-graphql.api.livecontrol.io',

        // 'https://ywlhrbztnfeodfhc2nxkk3rhwy.appsync-api.us-west-1.amazonaws.com',
        GRAPHQL_URI: 'https://scheduler-graphql.api.livecontrol.io',
        REST_URI: 'https://scheduler-rest.api.livecontrol.io',
        APPSYNC_REGION: 'us-west',
        WEBPLAYER_CONTROL_URI: 'https://lc-venue-api.ngrok.io',
        DEMO_CUSTOMER_IDS: [],
        VERSION: '2.7.1',
        WEBSOCKET_URI: 'wss://scheduler-graphql.api.livecontrol.io/graphql',
        DASHBOARD_URI: 'http://localhost:4200',
        ADMIN_DASHBOARD_URI: 'http://livecontrol-admin-dashboard-stg.s3-website-us-west-1.amazonaws.com',
        EVENTS_WEBSOCKET: 'wss://scheduler-ws.api.livecontrol.io',
        /* Deployed dev stack. Offline instead? http://localhost:4000/{stage} + ws://localhost:3001. */
        SERVERLESS_URL: 'https://8tv43ypam5.execute-api.us-west-2.amazonaws.com/dev',
        SERVERLESS_WEBSOCKET: 'wss://divrhkbxjl.execute-api.us-west-2.amazonaws.com/dev',
        ANALYTICS_URL: 'https://nximkrfkud.execute-api.us-west-1.amazonaws.com/pro'
      });
